@if (searchTerm) {
  <mat-form-field
    class="display-flex ui-form-field-v2"
    appearance="outline"
    [subscriptSizing]="description || showClearButton ? 'dynamic' : 'fixed'"
    [floatLabel]="floatLabel"
  >
    @if (label) {
      <mat-label>{{ label }}</mat-label>
    }
    <input
      #input
      type="text"
      [placeholder]="placeholder ? (placeholder | translate) : ''"
      matInput
      [formControl]="searchTerm"
      [errorStateMatcher]="errorStateMatcher"
      [matAutocomplete]="auto"
      [required]="required"
    />
    @if (showErrorIcon) {
      <span matIconSuffix class="ui-form-field__status-icon" aria-hidden="true">
        <mat-icon class="ui-form-field__icon">error_outline</mat-icon>
      </span>
    } @else if (showClearButton && hasValue && searchTerm.enabled) {
      <button
        type="button"
        mat-icon-button
        matIconSuffix
        class="ui-form-field__icon-button"
        [attr.aria-label]="'clear' | translate"
        (click)="clearInput($event)"
      >
        <mat-icon class="ui-form-field__icon">highlight_off</mat-icon>
      </button>
    } @else if (showClearButton) {
      <span matIconSuffix class="ui-form-field__suffix-spacer" aria-hidden="true"></span>
    }
    @if (description) {
      <mat-hint>{{ description }}</mat-hint>
    }
    @let errorText = searchTerm.errors | joinErrorMessages: messages;
    <mat-error [attr.title]="errorText">{{ errorText }}</mat-error>
    <mat-autocomplete
      #auto="matAutocomplete"
      class="app-ui-select"
      [displayWith]="nameof"
      (optionSelected)="onChange($event)"
    >
      @if (showList) {
        @for (option of filteredOptions | async; track option.id) {
          <mat-option
            [value]="option"
            [ngClass]="option.optionClass"
            (onSelectionChange)="onSelect($event, option)"
            (click)="search()"
          >
            @if (renderIcons) {
              <mat-icon>{{ option.name | translate }}</mat-icon>
            }
            {{ option.name | translate }}
            @if (option.optionSuffix) {
              ({{ option.optionSuffix | translate }})
            }
          </mat-option>
        }
      }
    </mat-autocomplete>
  </mat-form-field>
}
